import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const userImporterSelectors =
  importerSelectors('user.importer')

export default userImporterSelectors
